import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { DataTable } from "CommonComponent";
import { Columns } from "./component";

const TotalTabs = ({ direction_id, extraFiltersState }) => {
  const navigate = useNavigate();
  const { data, loading } = useSelector(
    (state) => state.acdReportState.monthlyTotal
  );
  const session = useSelector((s) => s.session);

  const getActions = (row) => {
    if (row.month === "Total") {
      return null;
    }

    return (
      <div className="d-flex align-items-center gap-2">
        {/*AccessRights(
            session.current_page_permissions,
            "view",
            row.created_by
          ) && row.is_deleted === "n" && (*/
        <img
          src="/assets/images/view-icon.svg"
          alt="View"
          style={{ cursor: "pointer" }}
          onClick={() => handleReportDetailClick(row)}
        />
        /*)*/}
      </div>
    );
  };

  const handleReportDetailClick = (row) => {
    const params = new URLSearchParams();
    params.append("program_id", row.program_id);
    params.append("direction_id", direction_id);
    
    if (row.month) {
      const [monthName, year] = row.month.split(" ");
      const month = new Date(Date.parse(monthName + " 1, " + year)).getMonth() + 1;
      params.append("month", month);
      params.append("year", year);
    }

    navigate(`/dailyACD?${params.toString()}`);
  };


  return (
    <div>
      <DataTable
        columns={Columns(getActions)}
        data={data}
        serverSide={false}
        showSearch={false}
        loading={loading}
        className="table-container"
      />
    </div>
  );
};

export default TotalTabs;

